<template>
  <div class="prevMatch">
    <p class="title">지난경기</p>
    <div class="matchBox" v-if="prevGameStatus">
      <div class="bgLogo">
        <div class="bannerTitle">
          <img v-if="item.league_name !== 'kleague'" src="@/assets/img/web/ico_facup.png" width="50" alt="banner_img">
          <img v-else src="@/assets/img/web/kleague_ico.png" alt="banner_img" width="80">
        </div>
        <div class="matchBox">
          <div class="info pc" :class="{ top: isEmpty(item.highlight)}">
            <div class="bannerTitle">
              <img v-if="item.league_name !== 'kleague'" src="@/assets/img/web/ico_facup.png" width="50" alt="banner_img">
              <img v-else src="@/assets/img/web/kleague_ico.png" alt="banner_img" width="80">
            </div>
            <div class="stadium">{{ item.game_date }}<span>({{item.game_yoil}}요일)</span></div>
            <div class="field">
              {{ item.field_name }}
              <img src="@/assets/img/icon/icon_map.png" alt="" width="12">
            </div>
          </div>

          <div class="game-div"></div>

          <div>
            <div class="game">
              <div class="emblem">
                <img :src="getEmblem(item.home_team)" alt="">
                <p>{{item.home_team_name}}</p>
              </div>
              <div class="score home" :class="{active: item.home_team === 'K07'}">{{item.home_team_goal}}</div>
              <div class="vs">
                <p class="title">VS</p>
                <p class="place">{{item.type}}</p>
              </div>
              <div class="score away" :class="{active: item.away_team === 'K07'}">{{item.away_team_goal}}</div>
              <div class="emblem">
                <img :src="getEmblem(item.away_team)" alt="">
                <p>{{item.away_team_name}}</p>
              </div>
            </div>
            <div class="info">
              <div class="stadium">{{ item.game_date }}</div>
              <div class="field">
                {{ item.field_name }}
                <img src="@/assets/img/icon/icon_map.png" alt="" width="12">
              </div>
            </div>
            <div class="btnBox" v-if="item.league_name === 'kleague'">
              <router-link :to="{name: 'matchDetail', params: { id: item.detail, item: item }}" class="record">경기기록</router-link>
              <router-link :to="{name: 'matchDetail', params: { id: item.detail, item: item }, query: {tab: 2}}" class="highlight">하이라이트</router-link>
            </div>
            <div class="btnBox" v-else-if="item.league_name === 'facup'">
              <a :href="item.highlight" target="_blank" class="highlight">하이라이트</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="noData">
        지난경기가 없습니다.
        <!--{{this.seasonType ? '지난경기가 없습니다.' : '준비 중입니다'}}-->
      </p>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import {getEmblem, isEmpty} from '@/lib';
import {leagueName} from "@/lib/match";

export default {
  name : 'PrevMatch',
  props: {
    prevGames: {
      type: Array,
      default: () => []
    },
    prevGameStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      item : {},
      seasonType: this.$store.getters['getSeasonType'],
    }
  },
  watch: {
    prevGames: {
      handler: function () {
        this.init()
      },
      deep: true
    }
  },
  mounted () {
  },
  methods: {
    isEmpty,
    getEmblem,
    init() {
      // eslint-disable-next-line vue/no-mutating-props
      // if(!this.seasonType) this.prevGameStatus = this.seasonType;
      if(!this.prevGameStatus) return;

      this.item = this.prevGames[0];
      this.item.league_name = leagueName(this.item.meet_name);
      if(this.item.home_team === 'K07') {
        this.item.type = '홈';
      } else {
        this.item.type = '어웨이';
      }
      this.item.detail = `${this.item.game_date.split('.')[0]}_${this.item.meet_seq}_${this.item.game_id}`;
    }
  }
}
</script>
<style scoped>
.noData {
  text-align: center;
  padding: 50px 0;
  font-size: 16px;
  color: #FFF;
}
.mainPage .prevMatch .matchBox .matchBox .info.pc {
  top: 0;
}
.mainPage .prevMatch .matchBox .matchBox .info.pc.top {
  top: 0;
  width: 110px;
}

/* 메인 경기 박스만 적용 */
@media (min-width: 1100px) {
  .game-div:before {
    content: "";
    display: block;
    position: relative;
    left: 0;
    width: 1px;
    height: 162px;
    background: #eee;
  }
  .prevMatch .matchBox .bgLogo .game {
    padding-bottom: 24px;
  }
}
.prevMatch .matchBox .matchBox {
  padding: 0;
  align-items: flex-start;
}

.prevMatch .matchBox .bgLogo .game {
  top: 0;
}
.prevMatch .matchBox .matchBox .game:before {
  display: none;
  top: 0;
}
.prevMatch .matchBox .btnBox {
  position: initial;
}
</style>
